import React, { Component } from 'react';
import { callApi } from '../utils';
import { showInfo, showError } from '../actions/notificationActions';
import { connect } from 'react-redux';
import LoadingDots from './LoadingDots';

import AutoSuggestInput from './AutoSuggestInput';
import Checkbox from './Checkbox';

const REASONS = [
  { value: 1, title: 'I was debited without a Token' },
  { value: 2, title: 'I cannot make payment with my ATM Card' },
  { value: 3, title: "I don't know how to use a feature" },
];

export default connect((state) => ({
  ...state.order.lastTransaction,
  meterHistory: state.user.meterHistory,
  user: state.user,
}))(
  class SupportForm extends Component {
    state = {
      done: false,
      loading: false,
      reason: '',
      otherReasons: '',
      message: '',
      submitBtn: 'I understand, Proceed',
      email: this.props.user.email,
      meterNo: this.props.meterNo || '',
      transactionId: '',
      name: '',
      phone: '',
    };

    setInput = (e) => {
      const { name, value } = e.target;
      this.setState({ [name]: value });
    };

    submitForm = (e) => {
      const { reason, otherReasons, message, email, meterNo, transactionId, name, phone } =
        this.state;
      e.preventDefault();

      this.setState({ loading: true, submitBtn: 'Please Wait' });

      let params = { reason, otherReasons, message, email, userId: this.props.user.id };

      if (!params.userId) {
        if (!name || !phone || !email) {
          this.setState({ loading: false, submitBtn: 'Send Message' });
          this.props.dispatch(showError('Kindly fill the required fields'));
          return;
        } else {
          params.name = name;
          params.phone = phone;
        }
      }

      if (reason === '1') {
        params.meterNumber = meterNo;
        params.transactionId = transactionId;
      }

      callApi('/sendmail', params, 'post')
        .then((res) => {
          this.setState({ loading: false, submitBtn: 'Send Message', });
          this.props.dispatch(showInfo(res));
        })
        .catch((err) => {
          console.error(err);
          this.setState({ loading: false, submitBtn: 'Send Message' });
          this.props.dispatch(showError(err));
        });
    };

    render() {
      const { submitBtn, loading, email, reason, name, phone, meterNo } = this.state;
      const { home } = this.props;

      return (
        <form
          onSubmit={this.submitForm}
          className="mt-4 order-form"
          style={{ width: '100%', maxWidth: '100%' }}
        >
          {!this.props.user.email && (
            <React.Fragment>
              <label>Name</label>
              <input name="name" type="text" value={name} onChange={this.setInput} />

              <label>Phone</label>
              <input name="phone" type="tel" value={phone} onChange={this.setInput} />
            </React.Fragment>
          )}

          <label>Email</label>
          <input name="email" type="email" value={email} onChange={this.setInput} />

          <label>Reason</label>
          <div className="select" style={home ? { marginBlockStart: '55px' } : null}>
            <select value={this.state.reason} onChange={this.setInput} name="reason" required>
              <option value="">Please select a Reason</option>

              {REASONS.map((r) => (
                <option key={r.value} value={r.value}>
                  {r.title}
                </option>
              ))}
            </select>
            <div className="select-border" />
            <div className="select-arrow" />
          </div>

          {reason === '1' ? (
            <div>
              {/* <label>Meter Number</label>
              <input name="meterNumber" type="text" onChange={this.setInput} required /> */}

              <label>Meter Number</label>
              <AutoSuggestInput
                type="tel"
                value={meterNo}
                id="meter-suggest"
                showAddBtn={!!this.props.meterNo}
                data={this.props.meterHistory || []}
                onSelect={(obj) => {
                  this.setState({ meterNo: obj.meterNo });
                }}
                onChange={this.setInput}
                properties={['meterNo', 'address']}
                autoFocus="true"
              />

              <label>Transaction ID</label>
              <input name="transactionId" type="text" onChange={this.setInput} required />
            </div>
          ) : null}
          <label>Other Reason (Optional)</label>
          <input name="otherReasons" type="text" onChange={this.setInput} />

          <label>Description</label>
          <textarea
            className="full-width"
            name="message"
            placeholder="Type your message here..."
            value={this.state.message}
            onChange={this.setInput}
            style={home ? { marginBlockStart: '55px' } : null}
          />
          <br />
          <div className="contact_us_tnc">
            <ol>
              <li>Ensure the email you are providing is active and valid.</li>
              <li>
                Please wait for a period of 24 hours before sending another as sending multiple
                messages will reduce the response time as we try to resolve.
              </li>
              <li>Kindly check your inbox and/or spam for our response.</li>
            </ol>
          </div>

          <div style={{ display: 'flex', margin: '40px 0', alignItems: 'flex-start' }}>
            <Checkbox checked />
            <div style={{ textAlign: 'justify' }}>
              &quot;By submitting this form, you consent to receive customer support text
              messages from BuyPower at the number provided. Msg & data rates may apply.
              Msg frequency varies. Reply STOP to unsubscribe or HELP for support. <br />
              <span><a href="https://buypower.ng/terms-of-use" target='_blank' rel="noopener noreferrer">
                View our Privacy Policy and Terms.
              </a></span>&quot;
            </div>
            <hr />
          </div>

          <button className="search-btn" type="submit" disabled={loading}>
            {submitBtn} <LoadingDots loading={loading} />
          </button>
        </form>
      );
    }
  }
);



// WEBPACK FOOTER //
// ./src/components/SupportForm.js